import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';

import _ from 'lodash';
import TableList from '@/components/TableList/index.vue';
import { queryPlaysmart } from '@/api/dashboard/material';
import { getPlayableReport } from '@/api/dashboard/report';
import adsTerms from '@/views/dashboard/ads-terms';
import { format } from 'date-fns';
import Pagination from '@com/components/pagination/index.vue';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';

export default {
  components: {
    TableList: TableList, Pagination: Pagination
  },
  data: function data() {
    return {
      engineOptions: [{ label: '旧版PS', value: 1 }, { label: '新版PS', value: 7 }],
      list: [],
      query: {
        publishDateRange: '',
        dataDateRange: '',
        page: 1,
        page_size: 15,
        engine_type: 1
      },
      pagination: {
        total: 1
      },
      loading: true
    };
  },
  mounted: function mounted() {
    var query = _Object$assign({}, this.$route.query);
    if (query.sdate) {
      this.query.page = query.page;
      this.query.page_size = query.page_size;
      this.query.publishDateRange = [new Date(Number(query.sdate)), new Date(Number(query.edate))];
      this.query.dataDateRange = [new Date(Number(query.sdate1)), new Date(Number(query.edate1))];
      this.query.engine_type = query.engine_type;
    } else {
      this.query.publishDateRange = [Date.now() - 30 * 24 * 60 * 60 * 1000, Date.now()];
      this.query.dataDateRange = [Date.now() - 30 * 24 * 60 * 60 * 1000, Date.now()];
    }
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, list, report, midsReport;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.$router.push({
                  name: _this.$route.name,
                  query: {
                    page: _this.query.page,
                    page_size: _this.query.page_size,
                    sdate: Number(_this.query.publishDateRange[0]),
                    edate: Number(_this.query.publishDateRange[1]),
                    sdate1: Number(_this.query.dataDateRange[0]),
                    edate1: Number(_this.query.dataDateRange[1]),
                    engine_type: _this.query.engine_type
                  }
                });
                _context.prev = 2;
                _context.next = 5;
                return queryPlaysmart({
                  engine_type: _this.query.engine_type,
                  sdate: format(_this.query.publishDateRange[0], 'YYYYMMDD'),
                  edate: format(_this.query.publishDateRange[1], 'YYYYMMDD'),
                  page: _this.query.page,
                  page_size: _this.query.page_size
                });

              case 5:
                res = _context.sent;

                _this.list = [];
                list = _.get(res, 'data.data.list');

                _this.pagination.total = _.get(res, 'data.data.total');
                _context.t1 = _;
                _context.next = 12;
                return getPlayableReport({
                  sdate: format(_this.query.dataDateRange[0], 'YYYYMMDD'),
                  edate: format(_this.query.dataDateRange[1], 'YYYYMMDD'),
                  mids: list.map(function (l) {
                    return l.mid;
                  }).join(','),
                  groups: 'mid'
                });

              case 12:
                _context.t2 = _context.sent;
                _context.t0 = _context.t1.get.call(_context.t1, _context.t2, 'data.data.list');

                if (_context.t0) {
                  _context.next = 16;
                  break;
                }

                _context.t0 = [];

              case 16:
                report = _context.t0;
                midsReport = {};

                report.map(function (item) {
                  midsReport[item.mid] = item;
                });
                list.forEach(function (item, index) {
                  item.categoryName = _this.categoryName(item.category_id);
                  item.created_time = format(item.created_time * 1000, 'YYYY-MM-DD');
                  item.has_offer = item.has_offer > 0 ? '是' : '否';
                  if (typeof midsReport[item.mid] !== 'undefined') {
                    item.impression = midsReport[item.mid].impression;
                    item.click = midsReport[item.mid].click;
                    item.install = midsReport[item.mid].install;
                    item.revenue = '$' + (midsReport[item.mid].revenue / 1000).toFixed(2);
                    item.eCPM = item.impression > 0 ? adsTerms.eCPM.compute(midsReport[item.mid].revenue, item.impression) : '-';
                  } else {
                    item.impression = 0;
                    item.click = 0;
                    item.install = 0;
                    item.revenue = '$0';
                    item.eCPM = '-';
                  }
                  item.ctr = item.impression > 0 ? (adsTerms.ctr.compute(item.click, item.impression) * 100).toFixed(2) + '%' : '-';
                  item.cvr = item.install > 0 ? (adsTerms.cvr.compute(item.click, item.install) * 100).toFixed(2) + '%' : '-';
                  item.ivr = item.impression > 0 ? (adsTerms.ivr.compute(item.install, item.impression) * 100).toFixed(2) + '%' : '-';
                });
                _this.loading = false;
                _this.list = list;
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t3 = _context['catch'](2);

                console.log(_context.t3);
                _this.$message('暂无数据');

              case 28:
                _context.prev = 28;

                _this.loading = false;
                return _context.finish(28);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 24, 28, 31]]);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.query.page = page;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.query.page = 1;
      this.query.page_size = size;
      this.fetchData();
    },
    search: function search() {
      this.query.page = 1;
      this.fetchData();
    },
    categoryName: function categoryName(v) {
      switch (v) {
        case 1:
          return '动态endcard';
        case 2:
          return 'playable 2d';
        case 3:
          return 'playable 3d';
        case 4:
          return '交互视频';
        case 5:
          return '全景';
        default:
          return v;
      }
    },
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
          $index = _ref.$index;

      return h(
        'el-popover',
        {
          attrs: {
            placement: 'top-start',
            title: adsTerms[column.property].fullName,
            width: '200',
            trigger: 'hover'
          }
        },
        [adsTerms[column.property].formula, h(
          'span',
          { slot: 'reference' },
          [adsTerms[column.property].name]
        )]
      );
    },
    exportSheet: function exportSheet() {
      var query = {
        engine_type: this.query.engine_type,
        sdate1: format(this.query.publishDateRange[0], 'YYYYMMDD'),
        edate1: format(this.query.publishDateRange[1], 'YYYYMMDD'),
        sdate2: format(this.query.dataDateRange[0], 'YYYYMMDD'),
        edate2: format(this.query.dataDateRange[1], 'YYYYMMDD')
        // http://playable.dev.com:8066/dashboard/playsmart/export?sdate1=20210401&edate1=20210430&sdate2=20210401&edate2=20210430
      };downloadWithNewWindow(v2Host + '/dashboard/playsmart/export?' + qs.stringify(query));
    }
  }
};